import { forwardRef } from "react";
import TeamExpensesReport from "./TeamExpensesReport";

/**
 * Operations Expenses Report — same template as the Team Expenses Report but
 * driven by the "overhead" expense type, matching the Operations tab on the
 * Performance Overview page.
 */
const OperationsExpensesReport = forwardRef(function OperationsExpensesReport(
  props,
  ref
) {
  return (
    <TeamExpensesReport
      {...props}
      ref={ref}
      expenseType="overhead"
      reportTitle={"Operations Expenses\nOverview Report"}
    />
  );
});

export default OperationsExpensesReport;
